import { sendNotification, useTranslation } from '@msdk/common'
import { stringFormat } from '@msdk/forms'
import { useBusinessUnitList } from 'state/business-unit/hooks'

export function useNotifyDefaultClinic() {
  const buList = useBusinessUnitList()
  const t = useTranslation()
  if (decodeURIComponent(document.cookie).includes('DefaultClinic')) {
    const DefaultClinic = getCookie('DefaultClinic')
    if (DefaultClinic && window.location.pathname.split('/').length > 2) {
      const clinicName = buList?.find((x) => x.id == DefaultClinic)?.fields['NAME']?.value
      removeCookie('DefaultClinic')
      if (clinicName) {
        const message = stringFormat(t('CMPS_DEFAULT_CLINIC_SET', '{0} was set as default clinic'), clinicName)
        sendNotification({ message, status: 'success' })
      }
    }
  }
}

function getCookie(cookieName: string) {
  const name = cookieName + '='
  const allCookiesString = decodeURIComponent(document.cookie)
  const allCookiesArray = allCookiesString.split(';')
  for (let i = 0; i < allCookiesArray.length; i++) {
    const cookie = allCookiesArray[i].trimStart()
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length)
    }
  }
  return ''
}

function removeCookie(cookieName: string) {
  let domain = window.location.hostname
  const splitted = domain.split('.')
  if (splitted.length > 2) {
    domain = `.${splitted[splitted.length - 2]}.${splitted[splitted.length - 1]}`
  }
  document.cookie = cookieName + `= ; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}`
}
